import { useEffect, useRef } from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import moment from "moment/moment";
import ReportSummaryContainer from "./ReportSummaryContainer";
import { useGetReportSummary, useLocalSampleSummaryParams } from "../../hooks";

import "./report-summary-pdf.module.scss";
import useIsPageLoaded from "./hooks/useIsPageLoaded";

type Props = {
  onFinishedDownloading?: () => void;
};

const ReportSummaryContainerPDFExport = ({ onFinishedDownloading }: Props) => {
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const { data: report } = useGetReportSummary(hash, sourceId, relationshipId);

  const isLoaded = useIsPageLoaded();

  const pdfExportComponent = useRef<PDFExport>(null);

  useEffect(() => {
    if (isLoaded) {
      pdfExportComponent.current?.save();
      // Wait for the PDF to prepare before calling the callback
      setTimeout(() => {
        onFinishedDownloading?.();
      }, 1000);
    }
  }, [isLoaded, onFinishedDownloading]);

  return (
    <div
      style={{
        position: "absolute",
        left: "-1000000px",
        top: 0,
        width: "1440px",
        overflow: "hidden"
      }}
    >
      <PDFExport
        ref={pdfExportComponent}
        paperSize={"auto"}
        margin={30}
        fileName={`${report?.sha1}_${moment().format("YYYY-MM-DD")}`}
      >
        <div style={{ width: "1500px" }}>
          <ReportSummaryContainer isPdfView />
        </div>
      </PDFExport>
    </div>
  );
};

export default ReportSummaryContainerPDFExport;
